import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { LazyIntegrationDetail } from './async.tsx';

export const IntegrationDetail = (): React.JSX.Element => (
	<LazyPage
		Page={LazyIntegrationDetail}
		pageId="async-jira-eoc-integration-automation"
		shouldShowSpinner
	/>
);
